"use client";

import Link from "next/link";
import { useTranslation } from "@/lib/i18n/context";

/**
 * Guides hub — a real index (not a placeholder) listing the guide resources.
 * Reuses the localized nav.guidesMenu so labels/links never drift from the
 * header dropdown. Removes the thin-content problem and adds internal links.
 */
export function GuidesIndexContent() {
  const { t, lang } = useTranslation();
  const isSl = lang !== "en";
  const items = t.landing.cover.nav.guidesMenu;
  const heading = t.landing.cover.nav.guides;
  const subtitle = isSl
    ? "Vse, kar ti pomaga izkoristiti Journail — navodila, novosti in zgodbe o namernem delu."
    : "Everything to help you get the most out of Journail — tutorials, what's new, and stories on intentional work.";

  return (
    <main className="mx-auto max-w-[1280px] px-6 pb-32 pt-12 text-[var(--ink)]">
      <header className="mb-10 border-b border-[var(--rule)]/30 pb-6">
        <p className="mb-2.5 flex items-center gap-2.5 font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-soft)]">
          <span className="h-1.5 w-1.5 rounded-full bg-[var(--terracotta)]" />
          {heading}
        </p>
        <h1 className="font-display text-[clamp(40px,5vw,64px)] leading-[0.95] tracking-[-0.025em] text-balance">
          {isSl ? "Vodniki in " : "Guides and "}
          <em className="font-medium italic text-[var(--terracotta)]">{isSl ? "viri" : "resources"}</em>.
        </h1>
        <p className="mt-3 max-w-[680px] font-display text-[17px] italic leading-[1.5] text-[var(--ink-soft)]">
          {subtitle}
        </p>
      </header>

      <ul className="mx-auto grid max-w-[820px] gap-4 sm:grid-cols-2">
        {items.map((item) => (
          <li key={item.href}>
            <Link
              href={item.href}
              className="group block h-full rounded-lg border border-[var(--rule)] bg-[var(--paper-2)]/30 p-5 transition hover:border-[var(--terracotta)]/50 hover:bg-[var(--paper-2)]/60"
            >
              <span className="font-display text-[19px] leading-snug text-[var(--ink)] group-hover:text-[var(--terracotta)]">
                {item.label} <span aria-hidden>→</span>
              </span>
              <span className="mt-1.5 block font-display text-[15px] leading-[1.6] text-[var(--ink-soft)]">
                {item.desc}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  );
}
